module.exports = __webpack_public_path__ + "img/banner_itemone_topimg.0858781f.png";